import { useState, useEffect } from 'react'

import { useRouter } from 'next/navigation'

import { useUserContext } from '@contexts/UserContext'
import ErrorService from '@services/error'
import { Localization } from '@services/localization/localization'
import { useStripeContext } from '@services/stripe'

const useAvailablePayment = () => {
  const [payment, setPayment] = useState('')
  const { getStripe } = useStripeContext()
  const { user } = useUserContext()
  const router = useRouter()

  useEffect(() => {
    try {
      const handleStripe = async () => {
        const stripe = await getStripe(
          Localization().getValuesFromRegion().stripeKey
        )

        const FAKE_PAYMENT_DATA = {
          country: 'US',
          currency: 'usd',
          requestPayerName: true,
          requestPayerEmail: true,
          total: {
            label: 'Total',
            amount: 10,
          },
        }

        if (stripe) {
          const paymentRequest = stripe.paymentRequest(FAKE_PAYMENT_DATA)
          const result = await paymentRequest.canMakePayment()
          if (result) {
            setPayment(result.applePay ? 'apple' : 'google')
          }
        }
      }
      handleStripe()
    } catch (error) {
      ErrorService.handleError({ error, router })
    }
  }, [getStripe, router])

  return user ? payment : ''
}

export { useAvailablePayment }
